import {
  conditionalFilterMessages,
  ConditionalFilters,
  useConditionalFilterContext,
} from "@dashboard/components/ConditionalFilter";
import { Box, Button, CloseIcon, DropdownButton, Popover, Text } from "@saleor/macaw-ui-next";
import React from "react";
import { useIntl } from "react-intl";

const FilterIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
    <path d="M1.5 3.5A.5.5 0 012 3h12a.5.5 0 01.5.5v1.586a.5.5 0 01-.146.353l-4.5 4.5a.5.5 0 00-.146.354V13.5a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-3.793a.5.5 0 00-.146-.354l-4.5-4.5A.5.5 0 011.5 5.086V3.5z"/>
  </svg>
);

export const ExpressionFilters = () => {
  const { formatMessage } = useIntl();
  const { valueProvider, containerState, filterWindow } = useConditionalFilterContext();
  const clearEmpty = () => {
    containerState.clearEmpty();
  };

  return (
    <Popover open={filterWindow.isOpen} onOpenChange={open => filterWindow.setOpen(open)}>
      <Popover.Trigger>
        <DropdownButton data-test-id="filters-button">
          <Box display="flex" alignItems="center" gap={1}>
            <FilterIcon />
            {formatMessage(conditionalFilterMessages.popoverTrigger, {
              count: valueProvider.count,
            })}
          </Box>
        </DropdownButton>
      </Popover.Trigger>
      <Popover.Content align="start" onInteractOutside={clearEmpty}>
        <Box __minHeight="250px" __minWidth="636px" display="grid" __gridTemplateRows="auto 1fr">
          <Popover.Arrow fill="default1" />
          <Box
            paddingTop={3}
            paddingX={3}
            paddingBottom={1.5}
            display="flex"
            gap={1}
            alignItems="center"
            justifyContent="space-between"
            backgroundColor="default1"
            borderTopLeftRadius={2}
            borderTopRightRadius={2}
          >
            <Text>{formatMessage(conditionalFilterMessages.popoverTitle)}</Text>
            <Box display="flex" alignItems="center" gap={2}>
              <Popover.Close>
                <Button variant="tertiary" icon={<CloseIcon />} onClick={clearEmpty} />
              </Popover.Close>
            </Box>
          </Box>
          <ConditionalFilters onClose={() => filterWindow.setOpen(false)} />
        </Box>
      </Popover.Content>
    </Popover>
  );
};
